import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './fonts/Telegraf/Telegraf-Regular.ttf';
import './fonts/Telegraf/Telegraf-UltraBold-800.ttf';
import './fonts/Telegraf/Telegraf-UltraLight-200.ttf';
import Provider from './app/provider'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider>
        <App />
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
